import { BANNER } from '../configs/ApiActionUrl';
import { httpService } from './httpService';
export const bannerService = {
    getAll,
    add,
    edit,
    update,
    deleteBanner,
    changeOrder
}

function getAll(){   
    return httpService.get(BANNER.GETALL)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}

function add(data){
    return httpService.post(BANNER.ADD, data, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
function edit(id){
    return httpService.get(BANNER.GET_INDIVIDUAL+"/"+id)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}
function update(code, data){
    return httpService.put(BANNER.UPDATE_INDIVIDUAL+"/"+code, data, {headers: {'Content-Type': 'multipart/form-data'}})   
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}


function deleteBanner (code){
    return httpService.delete(BANNER.DELETE+"/"+code, {headers: {'Content-Type': 'multipart/form-data'}}) 
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
    });
}

function changeOrder(code, newRankOrder){
    return httpService.put(BANNER.CHANGE_ORDER+"/rankOrder/"+code, {newRankOrder})   
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
